module.exports = __webpack_public_path__ + "img/meeting.44460976.png";